import type { DatasetIconProps } from "./DatasetIcon.type";

import { MdTextSnippet, MdOutlineTextSnippet } from "react-icons/md";

const FormIcon = ({ filled }: DatasetIconProps) => {
  return filled ? <MdTextSnippet /> : <MdOutlineTextSnippet />;
};

export default FormIcon;
